import { Box, Toolbar, useTheme } from '@mui/material';
import { PagesRoutes } from './PagesRoutes';

const PageContainer = ({ children }) => {
  const theme = useTheme();

  return (
    <Box sx={{ backgroundColor: theme.palette.background.default }}>
      <Toolbar />
      {/* <Typography variant={'h1'}>Delivery Promise</Typography> */}
      <PagesRoutes />
      {children}
    </Box>
  );
};

PageContainer.propTypes = {};

PageContainer.defaultProps = {};

export { PageContainer };
